<!--
  Note 1: <defs> element need to be outside of <symbol> element.
  FireFox failed to draw SVG image which references (via <use xlink:href="...">) internal SVG element
  which also references another internal SVG element in <defs> element.
  The solution was to put <defs> element outside <symbol> element.

  Note 2: When xlink:href reference only contains a fragment identifier (e.g. #<elementId>),
  while Chrome browser resolves it within the same document, Safari/FireFox try to resolve
  using base url set in <base href="..."> and fails.
  Chrome browser's behavior is correct according to this spec.
  https://www.w3.org/TR/SVG/linking.html#IRIforms
  As a work around, location path is prepend to a fragment identifier (e.g. <absolutePath>#<elementId>).
  * Another solution: the page http://sketchmaster.com/svg-optimizer can remove all <use></use> tags.

  Note 3: Avoid using clip-path="url(#elementId)" when base url is set.
  Safari requires location path in url() function. i.e. clip-path="url(<locationPath>#<elementId>)"
  Chrome fails to resolve if location path is present in url() function.
 -->
<svg
  *ngIf="locationPath$ | async as locationPath"
  xmlns="http://www.w3.org/2000/svg"
  id="svg-source"
  version="1.1"
  style="position: fixed; width: 0; height: 0"
>
  <style>
    use {
      fill-opacity: 1;
      fill: currentColor;
    }
  </style>

  <symbol id="success-icon" viewBox="0 0 16 16">
    <g id="Messaging" stroke="none" stroke-width="1" fill="none">
      <g
        id="Messaging-/-x_overrides-/-Status-Success"
        transform="translate(-8.000000, -24.000000)"
      >
        <g
          id="icon/Message/Success16"
          transform="translate(8.000000, 24.000000)"
        >
          <rect id="bounding-box" x="0" y="0" width="16" height="16"></rect>
          <g id="iconSuccess">
            <path
              d="M8,16 C12.418278,16 16,12.418278 16,8 C16,3.581722 12.418278,0 8,0 C3.581722,0 0,3.581722 0,8 C0,12.418278 3.581722,16 8,16 Z"
              id="Background"
              fill="#22A971"
            ></path>
            <polygon
              id="Combined-Shape"
              fill="#FFFFFF"
              points="6.2010256 9.8382602 10.9282516 3.78768687 12.2170334 4.78539998 6.35597141 12.2778604 6.35288112 12.2716116 6.35352188 12.2927621 3.2 9.14373677 4.32429297 7.96152756"
            ></polygon>
          </g>
        </g>
      </g>
    </g>
  </symbol>

  <symbol id="error-reset-icon" viewBox="0 0 16 16">
    <g
      id="icon/Message/Alert16"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <rect id="bounding-box" x="0" y="0" width="16" height="16"></rect>
      <g id="iconAlert">
        <circle id="Background" fill="#E80E51" cx="8" cy="8" r="8"></circle>
        <rect
          id="Stroke"
          fill="#FFFFFF"
          x="7"
          y="3"
          width="2"
          height="6"
        ></rect>
        <polygon id="Dot" fill="#FFFFFF" points="7 11 9 11 9 13 7 13"></polygon>
      </g>
    </g>
  </symbol>

  <symbol id="star-icon">
    <path
      d="M10 15l-5.878 3.09 1.123-6.545L.489 6.91l6.572-.955L10 0l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545z"
      fill="#FED86B"
      fill-rule="evenodd"
    />
  </symbol>

  <symbol id="spinner-icon" viewBox="0 0 50 50">
    <path
      fill="#FF6700"
      d="M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z"
    >
      <animateTransform
        attributeType="xml"
        attributeName="transform"
        type="rotate"
        from="0 25 25"
        to="360 25 25"
        dur="0.6s"
        repeatCount="indefinite"
      />
    </path>
  </symbol>

  <symbol id="google-icon" viewBox="0 0 48 48">
    <g>
      <path
        fill="#ea4335"
        d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"
      ></path>
      <path
        fill="#4285f4"
        d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"
      ></path>
      <path
        fill="#fbbc05"
        d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"
      ></path>
      <path
        fill="#34a853"
        d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"
      ></path>
      <path fill="none" d="M0 0h48v48H0z"></path>
    </g>
  </symbol>

  <symbol id="facebook-icon" viewBox="0 0 216 216">
    <path
      fill="#ffffff"
      d="M204.1 0H11.9C5.3 0 0 5.3 0 11.9v192.2c0 6.6 5.3 11.9 11.9 11.9h103.5v-83.6H87.2V99.8h28.1v-24c0-27.9 17-43.1 41.9-43.1 11.9 0 22.2.9 25.2 1.3v29.2h-17.3c-13.5 0-16.2 6.4-16.2 15.9v20.8h32.3l-4.2 32.6h-28V216h55c6.6 0 11.9-5.3 11.9-11.9V11.9C216 5.3 210.7 0 204.1 0z"
    ></path>
  </symbol>

  <symbol id="chevron-left-icon" viewBox="0 0 17 17">
    <g
      id="chevron-left"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g
        id="chevron-left"
        transform="translate(-24.000000, -86.000000)"
        fill="currentColor"
      >
        <g
          id="mobile/statement-details"
          transform="translate(0.000000, 64.000000)"
        >
          <path
            id="chevron-left"
            transform="translate(29.000000, 30.500000) scale(-1, 1) translate(-29.000000, -30.500000) "
            d="M25.53857,39 C25.1451135,39 24.751657,38.849125 24.4505711,38.547375 C23.8498096,37.943875 23.8498096,36.9656667 24.4505711,36.3621667 L30.2861374,30.5 L24.4505711,24.6378333 C23.8498096,24.0343333 23.8498096,23.056125 24.4505711,22.452625 C25.0520378,21.849125 26.0251022,21.849125 26.6265689,22.452625 L33.5494289,29.4070417 C34.1501904,30.01125 34.1501904,30.98875 33.5494289,31.5929583 L26.6265689,38.547375 C26.325483,38.849125 25.9320265,39 25.53857,39"
          ></path>
        </g>
      </g>
    </g>
  </symbol>

  <!-- <defs></defs> inside <symbol></symbol> might not work on firefox. see https://bugzilla.mozilla.org/show_bug.cgi?id=353575 -->
  <defs>
    <filter
      x="-34.6%"
      y="-39.8%"
      width="169.2%"
      height="198.4%"
      filterUnits="objectBoundingBox"
      id="filter-3"
    >
      <feOffset
        dx="0"
        dy="6"
        in="SourceAlpha"
        result="shadowOffsetOuter1"
      ></feOffset>
      <feGaussianBlur
        stdDeviation="9.5"
        in="shadowOffsetOuter1"
        result="shadowBlurOuter1"
      ></feGaussianBlur>
      <feColorMatrix
        values="0 0 0 0 0.729411765   0 0 0 0 0.82745098   0 0 0 0 0.984313725  0 0 0 1 0"
        type="matrix"
        in="shadowBlurOuter1"
        result="shadowMatrixOuter1"
      ></feColorMatrix>
      <feOffset
        dx="0"
        dy="3"
        in="SourceAlpha"
        result="shadowOffsetOuter2"
      ></feOffset>
      <feGaussianBlur
        stdDeviation="3"
        in="shadowOffsetOuter2"
        result="shadowBlurOuter2"
      ></feGaussianBlur>
      <feColorMatrix
        values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.0543195199 0"
        type="matrix"
        in="shadowBlurOuter2"
        result="shadowMatrixOuter2"
      ></feColorMatrix>
      <feMerge>
        <feMergeNode in="shadowMatrixOuter1"></feMergeNode>
        <feMergeNode in="shadowMatrixOuter2"></feMergeNode>
      </feMerge>
    </filter>
    <linearGradient
      x1="17.4766391%"
      y1="47.8601162%"
      x2="67.9555388%"
      y2="53.5190329%"
      id="linearGradient-4"
    >
      <stop stop-color="#ECF3FF" offset="0%"></stop>
      <stop stop-color="#4E87E3" offset="100%"></stop>
    </linearGradient>
    <filter
      x="-56.4%"
      y="-98.3%"
      width="212.8%"
      height="423.3%"
      filterUnits="objectBoundingBox"
      id="filter-6"
    >
      <feOffset
        dx="0"
        dy="19"
        in="SourceAlpha"
        result="shadowOffsetOuter1"
      ></feOffset>
      <feGaussianBlur
        stdDeviation="13"
        in="shadowOffsetOuter1"
        result="shadowBlurOuter1"
      ></feGaussianBlur>
      <feColorMatrix
        values="0 0 0 0 0.521568627   0 0 0 0 0.654901961   0 0 0 0 0.803921569  0 0 0 0.564849411 0"
        type="matrix"
        in="shadowBlurOuter1"
      ></feColorMatrix>
    </filter>
    <filter
      x="-180.0%"
      y="-145.9%"
      width="460.0%"
      height="391.9%"
      filterUnits="objectBoundingBox"
      id="filter-7"
    >
      <feOffset
        dx="0"
        dy="12"
        in="SourceAlpha"
        result="shadowOffsetOuter1"
      ></feOffset>
      <feGaussianBlur
        stdDeviation="8"
        in="shadowOffsetOuter1"
        result="shadowBlurOuter1"
      ></feGaussianBlur>
      <feColorMatrix
        values="0 0 0 0 0.521568627   0 0 0 0 0.654901961   0 0 0 0 0.803921569  0 0 0 0.564849411 0"
        type="matrix"
        in="shadowBlurOuter1"
        result="shadowMatrixOuter1"
      ></feColorMatrix>
      <feMerge>
        <feMergeNode in="shadowMatrixOuter1"></feMergeNode>
        <feMergeNode in="SourceGraphic"></feMergeNode>
      </feMerge>
    </filter>
  </defs>
  <symbol id="validate-prompt-icon" viewBox="0 0 75 76">
    <g id="mfa-***Web-flow" stroke="none" stroke-width="1" fill="none">
      <g
        id="mfa-2FA---Web-flow-1"
        transform="translate(-360.000000, -165.000000)"
      >
        <g id="mfa-Group-3" transform="translate(360.000000, 165.000000)">
          <g id="mfa-Group-2" transform="translate(0.000000, 13.356164)">
            <path
              d="M7.95797539,13.3561644 L70.1242164,13.3561644 C72.8170507,13.3561644 75,15.4913856 75,18.1253171 L75,56.8746829 C75,59.5086144 72.8170507,61.6438356 70.1242164,61.6438356 L7.95797539,61.6438356 C5.26515324,61.6438356 3.08219178,59.5086144 3.08219178,56.8746829 L3.08219178,18.1253171 C3.08219178,15.4913856 5.26515324,13.3561644 7.95797539,13.3561644 Z"
              id="mfa-Clip-2"
              fill="#A4EBD5"
            ></path>
            <path
              d="M4.88899386,6.16438356 L66.0014171,6.16438356 C68.7015473,6.16438356 70.890411,8.32898872 70.890411,10.9991942 L70.890411,52.6994359 C70.890411,55.3696293 68.7015473,57.5342466 66.0014171,57.5342466 L4.88899386,57.5342466 C2.18887589,57.5342466 0,55.3696293 0,52.6994359 L0,10.9991942 C0,8.32898872 2.18887589,6.16438356 4.88899386,6.16438356 Z"
              id="mfa-Clip-5"
              fill="#FFFFFF"
            ></path>
            <polyline
              id="mfa-Stroke-7"
              stroke="#162D3D"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              points="3.08219178 11.3013699 34.9315068 0 65.7534247 11.3013699"
            ></polyline>
            <path
              d="M3.62292718,11.2739726 C4.19069643,11.2739726 4.74315587,11.4579352 5.19737372,11.7979869 L5.19737372,11.7979869 L34.4178082,33.6739585 L63.6382379,11.7979905 C64.2179728,11.3639756 64.9190678,11.2057134 65.583889,11.3005173 C66.2484496,11.395284 66.8769109,11.7429599 67.3115369,12.321428 C67.651657,12.774126 67.8356164,13.3247176 67.8356164,13.8906068 L67.8356164,13.8906068 L67.8356164,51.8630307 C67.8356164,52.58533 67.542182,53.2391673 67.0680142,53.7124837 C66.5931945,54.1864507 65.9371952,54.4794521 65.2126893,54.4794521 L65.2126893,54.4794521 L3.62292718,54.4794521 C2.89841995,54.4794521 2.24242087,54.1864514 1.76760165,53.7124849 C1.29343369,53.2391684 1,52.5853304 1,51.8630307 L1,51.8630307 L1,13.8906068 C1,13.1682727 1.2934564,12.5143683 1.76765172,12.0409967 C2.24246187,11.5670113 2.89843853,11.2739726 3.62292718,11.2739726 Z"
              id="mfa-Stroke-15"
              stroke="#162D3D"
              stroke-width="2"
            ></path>
          </g>
          <g id="mfa-Group" transform="translate(21.575342, 0.000000)">
            <rect
              id="mfa-Rectangle"
              fill="#00E591"
              x="0"
              y="11.3013699"
              width="26.7123288"
              height="23.630137"
              rx="3"
            ></rect>
            <rect
              id="mfa-Rectangle"
              stroke="#162D3D"
              stroke-width="2"
              x="1"
              y="12.3013699"
              width="24.7123288"
              height="21.630137"
              rx="3"
            ></rect>
            <circle
              id="mfa-Oval-7"
              stroke="#162D3D"
              stroke-width="2"
              fill="#FFFFFF"
              cx="13.3561644"
              cy="22.6027397"
              r="3.08219178"
            ></circle>
            <path
              d="M13.3561644,1 C15.3438477,1 17.1406283,1.8543244 18.4422784,3.22736798 C19.7627408,4.62025574 20.5753425,6.54562415 20.5753425,8.66998732 L20.5753425,8.66998732 L20.5753425,12.3561644 L6.1369863,12.3561644 L6.1369863,8.66998732 C6.1369863,6.54562415 6.94958794,4.62025574 8.27005037,3.22736798 C9.57170046,1.8543244 11.3684811,1 13.3561644,1 Z"
              id="mfa-Oval"
              stroke="#162D3D"
              stroke-width="2"
            ></path>
          </g>
        </g>
      </g>
    </g>
  </symbol>

  <symbol id="facebook-round-icon" viewBox="0 0 128 128">
    <g>
      <g>
        <circle cx="64" cy="64" fill="#1877F2" r="64"></circle>
      </g>
      <g>
        <path
          d="M87.308,81.011l2.738-16.756h-19.39V51.479c0-5.276,1.415-9.029,8.981-9.029l11.2,0.005V25.559    c0,0-7.108-1.559-13.776-1.559c-13.915,0-23.124,9.19-23.124,24.79v15.466H37.162v16.756h16.771v46.193    c3.281,0.519,6.642,0.795,10.067,0.795c2.248,0,4.468-0.119,6.656-0.345V81.011H87.308z"
          fill="#FFFFFF"
        ></path>
      </g>
    </g>
  </symbol>

  <symbol id="dotted-spinner-icon" viewBox="0 0 20 20">
    <g
      id="Symbols"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g id="Spinner-/-Circle-Dots" fill="#23A474" fill-rule="nonzero">
        <path
          d="M4.34314575,2.64314575 C5.28202983,2.64314575 6.04314575,3.40426168 6.04314575,4.34314575 C6.04314575,5.28202983 5.28202983,6.04314575 4.34314575,6.04314575 C3.40426168,6.04314575 2.64314575,5.28202983 2.64314575,4.34314575 C2.64314575,3.40426168 3.40426168,2.64314575 4.34314575,2.64314575 Z"
          id="Dot"
          transform="translate(4.343146, 4.343146) rotate(-225.000000) translate(-4.343146, -4.343146) "
        ></path>
        <path
          d="M2,8.4 C2.8836556,8.4 3.6,9.1163444 3.6,10 C3.6,10.8836556 2.8836556,11.6 2,11.6 C1.1163444,11.6 0.4,10.8836556 0.4,10 C0.4,9.1163444 1.1163444,8.4 2,8.4 Z"
          id="Dot"
          opacity="0.949999988"
          transform="translate(2.000000, 10.000000) rotate(-270.000000) translate(-2.000000, -10.000000) "
        ></path>
        <path
          d="M4.34314575,14.1568542 C5.17157288,14.1568542 5.84314575,14.8284271 5.84314575,15.6568542 C5.84314575,16.4852814 5.17157288,17.1568542 4.34314575,17.1568542 C3.51471863,17.1568542 2.84314575,16.4852814 2.84314575,15.6568542 C2.84314575,14.8284271 3.51471863,14.1568542 4.34314575,14.1568542 Z"
          id="Dot"
          opacity="0.900000036"
          transform="translate(4.343146, 15.656854) rotate(-315.000000) translate(-4.343146, -15.656854) "
        ></path>
        <path
          d="M10,16.6 C10.7731986,16.6 11.4,17.2268014 11.4,18 C11.4,18.7731986 10.7731986,19.4 10,19.4 C9.22680135,19.4 8.6,18.7731986 8.6,18 C8.6,17.2268014 9.22680135,16.6 10,16.6 Z"
          id="Dot"
          opacity="0.849999964"
        ></path>
        <path
          d="M15.6568542,14.3568542 C16.3748244,14.3568542 16.9568542,14.9388841 16.9568542,15.6568542 C16.9568542,16.3748244 16.3748244,16.9568542 15.6568542,16.9568542 C14.9388841,16.9568542 14.3568542,16.3748244 14.3568542,15.6568542 C14.3568542,14.9388841 14.9388841,14.3568542 15.6568542,14.3568542 Z"
          id="Dot"
          opacity="0.800000012"
          transform="translate(15.656854, 15.656854) rotate(-225.000000) translate(-15.656854, -15.656854) "
        ></path>
        <path
          d="M18,8.8 C18.6627417,8.8 19.2,9.3372583 19.2,10 C19.2,10.6627417 18.6627417,11.2 18,11.2 C17.3372583,11.2 16.8,10.6627417 16.8,10 C16.8,9.3372583 17.3372583,8.8 18,8.8 Z"
          id="Dot"
          opacity="0.75"
          transform="translate(18.000000, 10.000000) rotate(-270.000000) translate(-18.000000, -10.000000) "
        ></path>
        <path
          d="M15.6568542,3.24314575 C16.2643675,3.24314575 16.7568542,3.73563253 16.7568542,4.34314575 C16.7568542,4.95065898 16.2643675,5.44314575 15.6568542,5.44314575 C15.049341,5.44314575 14.5568542,4.95065898 14.5568542,4.34314575 C14.5568542,3.73563253 15.049341,3.24314575 15.6568542,3.24314575 Z"
          id="Dot"
          opacity="0.699999988"
          transform="translate(15.656854, 4.343146) rotate(-315.000000) translate(-15.656854, -4.343146) "
        ></path>
        <path
          d="M10,0.5 C10.8284271,0.5 11.5,1.17157288 11.5,2 C11.5,2.82842712 10.8284271,3.5 10,3.5 C9.17157288,3.5 8.5,2.82842712 8.5,2 C8.5,1.17157288 9.17157288,0.5 10,0.5 Z"
          id="Dot"
        ></path>
      </g>
    </g>
  </symbol>

  <symbol id="apple-icon" viewBox="0 0 24 24">
    <g id="Logo-/-Apple" stroke="none" stroke-width="1" fill="none">
      <path
        d="M12.2375,5.5375 C13.125,5.5375 14.2375,4.9375 14.9,4.1375 C15.5,3.4125 15.9375,2.4 15.9375,1.3875 C15.9375,1.25 15.925,1.1125 15.9,1 C14.9125,1.0375 13.725,1.6625 13.0125,2.5 C12.45,3.1375 11.9375,4.1375 11.9375,5.1625 C11.9375,5.3125 11.9625,5.4625 11.975,5.5125 C12.0375,5.525 12.1375,5.5375 12.2375,5.5375 Z M9.1125,20.6625 C10.325,20.6625 10.8625,19.85 12.375,19.85 C13.9125,19.85 14.25,20.6375 15.6,20.6375 C16.925,20.6375 17.8125,19.4125 18.65,18.2125 C19.5875,16.8375 19.975,15.4875 20,15.425 C19.9125,15.4 17.375,14.3625 17.375,11.45 C17.375,8.925 19.375,7.7875 19.4875,7.7 C18.1625,5.8 16.15,5.75 15.6,5.75 C14.1125,5.75 12.9,6.65 12.1375,6.65 C11.3125,6.65 10.225,5.8 8.9375,5.8 C6.4875,5.8 4,7.825 4,11.65 C4,14.025 4.925,16.5375 6.0625,18.1625 C7.0375,19.5375 7.8875,20.6625 9.1125,20.6625 Z"
        id=""
        fill="#000000"
      ></path>
    </g>
  </symbol>
  <symbol id="checkmark-icon" viewBox="0 0 64 64">
    <g fill="none" fill-rule="evenodd">
      <path d="M0 0h64v64H0z" />
      <g transform="translate(4 4)">
        <circle cx="28" cy="28" r="28" fill="#22A971" />
        <path
          fill="#FFF"
          d="M38.76 14.67l3.27 2.45-17.86 22.82-.01-.01v.05L14 29.83l2.88-2.89 6.9 6.91z"
        />
      </g>
    </g>
  </symbol>

  <symbol id="error-icon" viewBox="0 0 64 64">
    <defs />
    <g fill="none" fill-rule="evenodd">
      <path d="M0 0h64v64H0z" />
      <g transform="translate(4 4)">
        <circle cx="28" cy="28" r="28" fill="#E80E51" />
        <path fill="#FFF" d="M26 16h4v16h-4zM26 36h4v4h-4z" />
      </g>
    </g>
  </symbol>
</svg>
